export function decodeBase64(input: string): string {
  if (!input) return '';
  if (!isValidBase64(input)) {
    return '';
  }

  try {
    const decodedString = window.atob(input);
    return decodedString;
  } catch (err) {
    console.error('Error decoding base64 string:', err);
    return '';
  }
}

export function encodeBase64(input: string): string {
  if (!input) return '';

  try {
    const encodedString = window.btoa(input);
    return encodedString;
  } catch (err) {
    console.error('Error encoding string to base64:', err);
    return '';
  }
}

export function isValidBase64(str: string) {
  try {
    return window.btoa(window.atob(str)) === str;
  } catch (err) {
    return false;
  }
}
